/**
 * @generated SignedSource<<0e925af5306c9050d7b74c92f915c4df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AskFellowHooksDeleteConversationMutation$variables = {
  conversationId: string;
};
export type AskFellowHooksDeleteConversationMutation$data = {
  readonly deleteAskCopilotConversation: {
    readonly success: boolean;
  } | null;
};
export type AskFellowHooksDeleteConversationMutation = {
  response: AskFellowHooksDeleteConversationMutation$data;
  variables: AskFellowHooksDeleteConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
      }
    ],
    "concreteType": "DeleteAskCopilotConversation",
    "kind": "LinkedField",
    "name": "deleteAskCopilotConversation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowHooksDeleteConversationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AskFellowHooksDeleteConversationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3b90a6af23a8a00f4e4914f1ca274de3",
    "id": null,
    "metadata": {},
    "name": "AskFellowHooksDeleteConversationMutation",
    "operationKind": "mutation",
    "text": "mutation AskFellowHooksDeleteConversationMutation(\n  $conversationId: ID!\n) {\n  deleteAskCopilotConversation(conversationId: $conversationId) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "5794248fed495f6b23842e65040d07d3";

export default node;
